/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';


export interface AppControllerHandleEvent$Params {
}

export function appControllerHandleEvent(http: HttpClient, rootUrl: string, params?: AppControllerHandleEvent$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<void>> {
  const rb = new CoreRequestBuilder(rootUrl, appControllerHandleEvent.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as CoreStrictHttpResponse<void>;
    })
  );
}

appControllerHandleEvent.PATH = '/o2-core/events';
